import type * as React from 'react'

import type { AllFeatureIds } from 'generated/featureIds.generated'

import hasFeature from 'modules/core/lib/hasFeature'

export default function renderIfFeature(feature: AllFeatureIds) {
  return (thunk: () => React.ReactNode): React.ReactNode => {
    if (!hasFeature(feature)) return null

    return thunk()
  }
}
